"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerHostSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const components_1 = require("@/app/SUMO/components");
const scheduler_1 = require("@/app/SUMO/store/scheduler");
const skeleton_1 = require("primereact/skeleton");
const react_redux_1 = require("react-redux");
const SchedulerHostSection = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const host = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectHost);
    const hostOptions = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectHostOptions);
    const isLoaded = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectIsSchedulerLoaded);
    const showHostError = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectShowHostError);
    const usersColor = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectSelectedUsersColors);
    const handleHostChange = (value) => {
        dispatch(scheduler_1.SUMO1SchedulerActions.setHost(value));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-8px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-med text-gray-80', children: labels_1.default.SCHEDULER_HOST_LABEL }), !isLoaded ? ((0, jsx_runtime_1.jsx)("div", { className: 'mr-20px', children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { className: 'border-radius-6px', height: '43px' }) })) : ((0, jsx_runtime_1.jsx)(components_1.HostSelect, { options: hostOptions, value: host, invalid: showHostError, usersColor: usersColor, onChange: (e) => handleHostChange(e.value), onHostRemove: () => handleHostChange(null), hidePlusButton: Boolean(host) }))] }));
};
exports.SchedulerHostSection = SchedulerHostSection;
